import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { b } from 'utils/i18nUtils';

import { Icon, StatusCard } from 'components/ui';

export enum PaymentStatus {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

const CONFIG_BY_STATUS = {
  [PaymentStatus.SUCCESS]: {
    title: {
      id: 'page.finalInvoice.modal.kioskInstruction.paidTitle',
      defaultMessage: 'Payment completed',
    },
    description: {
      id: 'page.finalInvoice.modal.kioskInstruction.landingContent',
      defaultMessage: 'Thank you for your payment! You can now <b>continue</b> your check-out <b>on the kiosk.</b>',
      values: { b: (text: ReactNode) => b(text, 'text-default text-lg') },
    },
    icon: <Icon className="fb-icon--check text-4xl text-white" />,
  },
  [PaymentStatus.FAILURE]: {
    title: {
      id: 'page.finalInvoice.modal.kioskInstruction.paymentFailure',
      defaultMessage: 'Payment failure',
    },
    description: {
      id: 'page.finalInvoice.modal.kioskInstruction.failureDescription',
      defaultMessage: 'Unfortunately we were unable to process the payment. Please <b>go back</b> to the <b>payment link</b> and try again.',
      values: { b: (text: ReactNode) => b(text, 'text-default text-lg') },
    },
    icon: <Icon className="fb-icon--close text-4xl text-white" />,
  },
};

const PaymentLanding: React.FC<{ status: PaymentStatus }> = ({ status }) => (
  <div className="flex justify-center items-center bg-cover bg-center bg-home relative min-h-screen">
    <StatusCard
      status={status === PaymentStatus.SUCCESS ? 'success' : 'failure'}
      header={<FormattedMessage {...CONFIG_BY_STATUS[status].title} />}
      icon={CONFIG_BY_STATUS[status].icon}
      description={<FormattedMessage {...CONFIG_BY_STATUS[status].description} />}
    />
  </div>
);

export default PaymentLanding;